import { getShiftsManageFilter } from '../../../../../backend/features/permissions/shared';
import { shiftEntityName } from '../../../../../backend/features/shift/shared';
import { SelectCard } from '../../../../../ui/features/volunteers-wizard-dialog/components/SelectSection';
import { useMissionsTranslation } from '../../../../../ui/hooks';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import { useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
import React from 'react';
export const ShiftSelect = (props) => {
    var _a;
    const userState = useUserState();
    const { t } = useMissionsTranslation();
    const shiftFilter = React.useMemo(() => {
        const filter = getShiftsManageFilter(userState);
        if (props.additionalShiftFilters) {
            filter.push(...props.additionalShiftFilters);
        }
        return filter;
    }, [props.additionalShiftFilters, userState]);
    const { data: shifts } = useStorageList(shiftEntityName, {
        filter: shiftFilter,
        orderBy: [{ column: 'startTime', desc: true }],
    });
    return (React.createElement(SelectCard, Object.assign({}, props, { options: shifts === null || shifts === void 0 ? void 0 : shifts.rows.map((shift) => ({
            label: `${t('date', { value: shift.columns.startTime })} ${t('time', { value: shift.columns.startTime })} - ${t('time', { value: shift.columns.stopTime })} ${shift.columns.countyName}`,
            value: shift.id,
        })), title: (_a = props.title) !== null && _a !== void 0 ? _a : t('shiftVolunteerManagementWizard.titles.selectShift'), selectLabel: t('shiftVolunteerManagementWizard.labels.shift'), noOptionsLabel: t('shiftVolunteerManagementWizard.labels.noShifts'), selectLabelId: 'shift' })));
};
